import React, {useEffect, useState} from "react";
import {Stack} from "@fluentui/react";

import styles from "./ConstructionCalculationsNote.module.scss";
import IsaacLoading from "../../components/isaacLoading/IsaacLoading";
import useConstructionCalculationsPageHookOrchestrator from "../constructionCalculationsNew/hooks/useConstructionCalculationsPageHookOrchestrator";
import ConstructionCalculationsBodyNew from "../constructionCalculationsNew/components/body/ConstructionCalculationsNewBody";
import ConstructionBody from "../constructionNew/components/body/ConstructionBody";
import IsaacPills from "../../components/isaacPills/IsaacPills";
import IsaacPdfViewer from "../../components/isaacPdfViewer/IsaacPdfViewer";
import useLoadPdfFromBlob from "./hooks/useLoadPdfFromBlob";
import useLoadFoundationResults from "./hooks/useLoadFoundationResults";
import CalculationNoteFoundationLoadCases from "./components/calculationNoteFoundationLoadCases/CalculationNoteFoundationLoadCases";

const ConstructionCalculationsNote: React.FunctionComponent = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const {result: url} = useLoadPdfFromBlob(
    "Calculation_Notes_Static_Data_v1.2.pdf",
  );

  const {
    loadPageData: loadingCalculationsData,
    construction,
    constructionDetails,
    selectedCalculationResults,
  } = useConstructionCalculationsPageHookOrchestrator();

  useLoadFoundationResults();
  useEffect(() => {
    const isEdge = navigator.userAgent.includes("Edg");

    if (!isEdge) {
      document.documentElement.classList.add("not-edge");
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    (async () => {
      await loadingCalculationsData();
      setLoading(false);
    })();
  }, [loadingCalculationsData]);

  return (
    <div className={styles.noteResultsContainer}>
      <IsaacLoading loading={loading} message="Loading calculations note..." />
      {!loading && (
        <main className={styles.noteBody}>
          {construction !== null && construction !== undefined && (
            <Stack.Item>
              <IsaacPills
                pills={[
                  {name: "Name", value: construction.name},
                  {name: "Location type", value: construction.constructionDetails.location.type.value},
                  {name: "Location code", value: construction.constructionDetails.location.code.value},
                ]}
              />
            </Stack.Item>
          )}
          {constructionDetails?.masts?.map((mast) => (
            <div key={mast.mastId}>
              <ConstructionCalculationsBodyNew
                key={mast.number}
                construction={construction}
                constructionDetails={constructionDetails}
                selectedMastNo={mast.number}
                calculationResults={selectedCalculationResults}
              />
              <CalculationNoteFoundationLoadCases mastNo={mast.number} />
            </div>
          ))}

          <Stack.Item className={styles.noteConstructionData}>
            <h2
              className={`${styles.noteConstructionDataTitle} ${styles.noPrint}`}>
              Construction data
            </h2>
            <h2
              className={`${styles.noteConstructionDataTitle} ${styles.print}`}>
              1.2. Construction data
            </h2>
            {construction && (
                <ConstructionBody construction={construction} />
            )}
          </Stack.Item>

          {url && construction && (
            <IsaacPdfViewer constructionNo={construction.number} url={url} />
          )}
        </main>
      )}
    </div>
  );
};

export default ConstructionCalculationsNote;


